module.exports = __webpack_public_path__ + "static/media/no-suppliers.96088f68.svg";